import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './BusinessOperationComponent.metadata.json5';
import styles from '../../../pages/Accountant/AccountantPage.module.scss';
import FormPredecesFirmComponent from '../Subcomponents/FormerPredecessorFirms/FormPredecesFirmComponent';
import ProPartOffInfoComponent from '../Subcomponents/ProPartOffInfo/ProPartOffInfoComponent';

function BusinessOperationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessOperationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const getTotNoOfEmp48 = () => {
        let sum = 0
        
        if(!_.isUndefined(modelVM.value.numOfNonCanEmp47)) {
            sum += modelVM.value.numOfNonCanEmp47
        }

        if(!_.isUndefined(modelVM.value.numOfParCanEmp46)) {
            sum += modelVM.value.numOfParCanEmp46
        }

        if(!_.isUndefined(modelVM.value.numOfFulCanEmp45)) {
            sum += modelVM.value.numOfFulCanEmp45
        }

        return sum

    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        totNumOfStaInCom60: { 
            value: getTotNoOfEmp48()
        },
        ifNoPleExp50: {
            visible: !_.isUndefined(modelVM.value.areAllEmpCovByWC49) && !modelVM.value.areAllEmpCovByWC49
        },
        exp52: {
            visible: !_.isUndefined(modelVM.value.areTheComItsParAssOr51) && modelVM.value.areTheComItsParAssOr51
        },
        exp54: {
            visible: !_.isUndefined(modelVM.value.havYouEveBroAClaOr53) && modelVM.value.havYouEveBroAClaOr53
        },
        desOfTheAppOthActFor40: {
            visible: !_.isUndefined(modelVM.value.oth39) && modelVM.value.oth39
        },
        formPredecesFirmComponent: {
            data: modelVM.formerPredecessor,
            updateWizardData,
            submissionVM,
            ForPredFirmPath: `${pathUpdated}.formerPredecessor`
        },
        proPartOffInfoComponent: {
            data: modelVM.proPartOffInfo,
            updateWizardData,
            submissionVM,
            ProPartOffInfoPath: `${pathUpdated}.proPartOffInfo`
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            formPredecesFirmComponent: FormPredecesFirmComponent,
            proPartOffInfoComponent: ProPartOffInfoComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessOperationComponent.propTypes = wizardProps;
export default withRouter(BusinessOperationComponent);
